/* eslint-disable react/no-unknown-property */
import React from 'react'

import Marker from '../objects/marker'
import { MarkerInterface } from './types'

const FONT_FAMILY =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"

const PIN_COLOR = '#374B45'
const PIN_COLOR_LIGHT = '#4F6A61'
const PIN_COLOR_DARK = '#243029'
const PIN_GRADIENT = `linear-gradient(225deg, ${PIN_COLOR_LIGHT} 0%, ${PIN_COLOR} 55%, ${PIN_COLOR_DARK} 100%)`

function MapIconMarker({
  position,
  title,
  subTitle,
  svg,
  visible,
  mainStyleOverride,
  svgStyleOverried,
  titleStyleOverried,
  subTitleStyleOverried,
}: MarkerInterface) {
  const size = 120
  const hasLabel = Boolean(title || subTitle)

  return (
    <group position={position} key={title}>
      <Marker maxScale={0.9} minScale={0.4} visible={visible} anchor="bottom">
        <div
          style={{
            position: 'relative',
            width: 10,
            height: '200px',
            fontFamily: FONT_FAMILY,
            userSelect: 'none',
            cursor: 'pointer',
            ...mainStyleOverride,
          }}
        >
          <span
            style={{
              position: 'absolute',
              left: '50%',
              bottom: 0,
              width: size,
              height: size,
              borderRadius: '50% 50% 50% 0%',
              backgroundColor: PIN_COLOR,
              backgroundImage: PIN_GRADIENT,
              border: '2px solid rgba(255, 255, 255, 0.9)',
              boxShadow:
                '0 4px 10px rgba(0, 0, 0, 0.35), inset 2px 2px 4px rgba(255, 255, 255, 0.18)',
              boxSizing: 'border-box',
              transform: 'translateX(0%) rotate(-45deg)',
              transformOrigin: 'bottom left',
            }}
          >
            <span
              style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transform: 'rotate(45deg)',
                color: '#ffffff',
                ...svgStyleOverried,
              }}
            >
              {svg ?? (
                <span
                  style={{
                    width: size * 0.4,
                    height: size * 0.4,
                    borderRadius: '50%',
                    background: '#ffffff',
                  }}
                />
              )}
            </span>
          </span>

          {hasLabel && (
            <span
              style={{
                position: 'absolute',
                top: '100%',
                left: '50%',
                marginTop: 6,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '4px 10px',
                borderRadius: 8,
                background: 'rgba(18, 18, 20, 0.86)',
                border: '1px solid rgba(255, 255, 255, 0.14)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.35)',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                color: '#ffffff',
                lineHeight: 1.2,
                textAlign: 'center',
                whiteSpace: 'nowrap',
                transform: 'translateX(-50%)',
              }}
            >
              {title && (
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    letterSpacing: 0.2,
                    ...titleStyleOverried,
                  }}
                >
                  {title}
                </span>
              )}
              {subTitle && (
                <span
                  style={{
                    fontSize: 11,
                    fontWeight: 400,
                    color: 'rgba(255, 255, 255, 0.7)',
                    ...subTitleStyleOverried,
                  }}
                >
                  {subTitle}
                </span>
              )}
            </span>
          )}
        </div>
      </Marker>
    </group>
  )
}

export default MapIconMarker
